import React, { useContext, useEffect, useState } from 'react';
import { SX_STYLES } from '../../styles/pages/ProductsStyles';
import { IMAGES } from '../../constants/Images';
import { Box, MenuItem, Typography } from '@mui/material';
import RoundedButton from '../../components/cores/RoundedButton';
import { products } from '../../helper/products';
import ListProduct from '../../components/listItems/ListProduct';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import RoundedInput from '../../components/cores/RoundedInput';
import CustomDropdown from '../../components/general/CustomDropdown';
import { productCategory } from '../../helper/category';
import { ArrowDownward } from '@mui/icons-material';
import { ROUTES } from '../../constants/Routes';
import { ServicesContext } from '../../components/provider/ServicesProvider';
import ListBreadCrumbs from '../../components/listItems/ListBreadCrumbs';
import { LABELS } from '../../constants/Labels';
import { useNavigate } from 'react-router-dom';

const Products = (props) => {
    const servicesContext = useContext(ServicesContext);
    const [pageNo, setPageNo] = useState(0);
    const [category, setCategory] = useState(1);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'instant'});
        var filtered = servicesContext.breadCrumbs.filter(function(el) { return el.crumb !== LABELS.PRODUCTS }); 
        servicesContext.setBreadCrumbs(filtered);
    }, []);

    const maxPage = Math.ceil(products.length/10);

    //for previous and next icon click
    const onNextPage = () => { 
        setPageNo((pageNo + 1)%maxPage);
    };
    const onPrevPage = () => {
        setPageNo((pageNo + 10 -1)%maxPage);
    };

    //for pagination number click
    const handleChange = (event, value) => {
        setPageNo((value - 1)%maxPage)
    };

    //for category dropdown click
    const handleChangeCategory = (event) => {
        setCategory(event.target.value);
    };

    const goToProductDetails = (item) => {
        let productDetails = {
            productItem: item,
            routeFrom: ROUTES.PRODUCTS
        }
        servicesContext.setBreadCrumbs(prevArray => [...prevArray, {crumb: LABELS.PRODUCTS}]);
        servicesContext.setProductData(productDetails);
        navigate(ROUTES.PRODUCT_DETAILS);
    }
    
    return (
        <Box>
            <Box>
                <Box sx={{height: '8.8vh'}}/>
                <Box component='div' sx={[SX_STYLES.section2Image, { backgroundImage: `url(${IMAGES.SECTION2})`, height: '75.4vh'}]}>
                    <Box sx={SX_STYLES.section2Container}>
                        <Typography sx={SX_STYLES.section2Label}>Products</Typography>
                        <Typography sx={SX_STYLES.section2title}>OXYSWING Oxygen Generator</Typography>
                        <Typography sx={SX_STYLES.section2body}>Allows the onsite production of medical oxygen. The more you<br/>use it, the more you save it.</Typography>
                        <Box sx={SX_STYLES.btnReadContainer}>
                            <RoundedButton variant='contained' text='Read Details' onClick={()=>goToProductDetails(products[0])}/>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={SX_STYLES.productsOfferedContainer}>
                <ListBreadCrumbs data={servicesContext.breadCrumbs} currentCrumb={LABELS.PRODUCTS}/>
                <Box sx={SX_STYLES.productsOfferedWrapper}>
                    <Box sx={SX_STYLES.servicesSectionContainer}>
                        <Typography sx={SX_STYLES.sectionLabel}>All Products</Typography>
                        <Typography sx={SX_STYLES.sectionSubLabel}>Hear from some of our amazing customers who are automating their finances.</Typography>
                    </Box>
                </Box>
            </Box>
            <Box sx={SX_STYLES.searchContainer}>
                <RoundedInput image={IMAGES.SEARCH} placeholder='Search'/>
                <CustomDropdown value={category} icon={<ArrowDownward sx={SX_STYLES.icon}/>} onSelect={handleChangeCategory}>
                    {productCategory.map((item, index) => (
                        <MenuItem sx={SX_STYLES.menu} value={item.id} key={index}>
                            {item.category}
                        </MenuItem>
                    ))}
                </CustomDropdown>
            </Box>
            <Box sx={SX_STYLES.listProductsContainer}>
                {
                    products.slice(pageNo*10,10*(pageNo+1)).map((item, index) => (
                            <Box key={index}>
                                <ListProduct image={item.image} title={item.title} body={item.body} onClick={()=>goToProductDetails(item)} small />
                            </Box>  
                        )
                    )
                }
            </Box>
            <Box sx={SX_STYLES.paginationContainer}>
                <Box sx={{marginRight: '0vw'}}>
                    <Pagination
                        sx={SX_STYLES.paginationStyle}
                        count={maxPage}
                        onChange={handleChange}
                        page={pageNo + 1}
                        renderItem={(item) => (
                            <PaginationItem
                                sx={SX_STYLES.pageNumber}
                                slots = {
                                            { 
                                                previous: (props) => (
                                                    <Box sx={[SX_STYLES.pagination, {marginRight: '15.35vw'}]}>
                                                        <ArrowBackIcon onClick={onPrevPage} sx={{fontSize: '2.5vh'}}/>
                                                        <Typography sx={SX_STYLES.paginationLabel}>Previous</Typography>
                                                    </Box>
                                                ), 
                                                next: (props) => ( 
                                                    <Box sx={[SX_STYLES.pagination, {marginLeft: '16.55vw'}]}>
                                                        <Typography sx={SX_STYLES.paginationLabel}>Next</Typography>
                                                        <ArrowForwardIcon onClick={onNextPage} sx={{fontSize: '2.5vh'}}/>
                                                    </Box>
                                                )
                                            }
                                        }
                                        {...item}
                            />
                        )}
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default Products;